import * as tslib_1 from "tslib";
import React from 'react';
import Fade from '../transitions/Fade';
import StyledBackdrop from './StyledBackdrop';
StyledBackdrop.displayName = 'StyledBackdrop';
export default function Backdrop(props) {
    return (React.createElement(Fade, tslib_1.__assign({ appear: true, in: props.open, timeout: props.transitionDuration }, props),
        React.createElement(StyledBackdrop, null)));
}
//# sourceMappingURL=Backdrop.js.map